import { get } from 'lodash';

export const getKittyName = (kitty) => {
  return get(kitty, 'bio.bio.name', kitty.name);
};
